import {
    apiRequest,
    kriteriaSkpTunsusDetail
} from "../../../../../services/adapters/kepegawaian/kriteriaSkpTunsusService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", kriteriaSkpTunsusDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository